// extracted by mini-css-extract-plugin
module.exports = {"PreviewCartBundleSection":"BundlesViewDetails_PreviewCartBundleSection__8OioI"};